mobileSize = 1050;

$(document).ready(function() {
	// Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1051) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1050) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Footer Things
	if ($('body').hasClass('saffireMobileSize')) {
		$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire-blue.png`);
		$('.footer-bottom').insertAfter('.footer');
	} else {
		$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire-yellow.png`);
		$('.footer-bottom').insertAfter('.footer-top');
	}
});

$(window).load(function() {
	$('body').addClass('pageIsLoaded');
	$('.getUpdatesPageEmailModule .emailSignup .emailSignupText').text('Sign up for the latest news and announcements from DryTown Water Park.');

	// Animations
	setTimeout(function() {
		$('.homepage .header-logo')
			.css('opacity', '1')
			.addClass('animate__animated animate__fadeInDownBig');
		$('#pool-float')
			.css('opacity', '1')
			.addClass('animate__animated animate__lightSpeedInRight');
	},1000);

	$('.ticket').hover(function() {
    $(this).addClass('animate__animated animate__swing');
  }, function() {
    $(this).removeClass('animate__swing');
  });

	// Weather Bug
  setInterval(function() {
		var str = $('#weatherBugDescription').text();
		var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
		if(!weatherBugSet && str != ''){
			$('#weatherBugWidget').addClass('weatherBugSet');
		    var findSpace = str.lastIndexOf(' ');
		    var stringLength = str.length;
		    var res = str.substring(findSpace, stringLength);
		    var start = str.substring(0, findSpace);
		    $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
		    $('#weatherBugWidget').css('visibility', 'visible');
		}
	},12);
});

$(window).resize(function() {
	// Footer Things
	if ($('body').hasClass('saffireMobileSize')) {
		$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire-blue.png`);
		$('.footer-bottom').insertAfter('.footer');
	} else {
		$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire-yellow.png`);
		$('.footer-bottom').insertAfter('.footer-top');
	}
});